import { DataGridColSettings } from '@/components/DataGrid/utils';

export const callRecordsCols: DataGridColSettings[] = [
  {
    field: 'callDirection',
    headerName: 'Call Direction',
    width: 140,
    visible: true,
  },
  {
    field: 'callId',
    headerName: 'Call ID',
    width: 340,
    visible: true,
  },
  {
    field: 'phoneNumber',
    headerName: 'Caller Number',
    width: 340,
    visible: true,
  },
  {
    field: 'externalCallId',
    headerName: 'Default Caller ID',
    visible: true,
  },
  {
    field: 'extension',
    headerName: 'Extension',
    visible: true,
  },
  {
    field: 'createdAt',
    headerName: 'Date and Time',
    visible: true,
  },
  {
    field: 'callResult',
    headerName: 'Call Result',
    visible: true,
  },
  {
    field: 'handledBy',
    headerName: 'Handled By',
    visible: true,
  },
  {
    field: 'disposition',
    headerName: 'Disposition',
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];
